import { Injectable } from '@angular/core';
import { pick } from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { TProject } from '../models/projects/project.model';

const PROJECT_KEY_IN_STROAGE = 'selected_project';

type TProjectInStore = {
  alias: string;
  name: string;
  initedSettings: boolean;
};

@Injectable({ providedIn: 'root' })
export class AppStore {
  private _project: BehaviorSubject<TProjectInStore | null>;

  constructor() {
    const currentProject = this.restoreProject();
    this._project = new BehaviorSubject(currentProject);
  }

  get project() {
    return this._project.asObservable();
  }

  private restoreProject() {
    const strData = localStorage.getItem(PROJECT_KEY_IN_STROAGE);
    if (!strData) return null;
    return JSON.parse(strData) as TProjectInStore;
  }

  setCurrentProject(project: TProject | null) {
    if (project) {
      if (!this._project.value || this._project.value.alias !== project.alias) {
        const nextValue = {
          ...pick(project, ['alias', 'name']),
          initedSettings: !!project.settings,
        };
        localStorage.setItem(PROJECT_KEY_IN_STROAGE, JSON.stringify(nextValue));
        this._project.next(nextValue);
      }
    } else {
      localStorage.removeItem(PROJECT_KEY_IN_STROAGE);
      this._project.next(null);
    }
  }
}
